import { ShowroomConfiguration } from '@typings';
import { createAction } from 'typesafe-actions';

export const fetchConfigurationRequest = createAction('config/CONFIGURATION_FETCH_REQUEST')<{ ignoreCache: boolean } | void>();
export const fetchConfigurationSuccess = createAction('config/CONFIGURATION_FETCH_SUCCESS')<ShowroomConfiguration.FullConfiguration>();

export const invalidConfiguration = createAction('config/CONFIGURATION_INVALID')<{ readonly message: string; error: string }>();

export const reloadPage = createAction('config/RELOAD_PAGE')();
